import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

import { FlightScaleSize } from '@design-system/components/atoms/flight-scale/entities/flight-scale.types';

@Component({
  selector: 'app-ds-flight-scale',
  templateUrl: './flight-scale.component.html',
  styleUrls: ['./flight-scale.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule]
})
export class FlightScaleDsComponent {

  @Input() size = FlightScaleSize.RG;
  @Input() stops = 0;
  
  constructor() { }

  get viewStops(): number {
    return (this.stops >= 2) ? 2 : (this.stops) === 1 ? 1 : 0;
  }

}
